/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function alert(options, context) {
    var _a;
    (_a = context === null || context === void 0 ? void 0 : context.PanguMiniAppCall) === null || _a === void 0 ? void 0 : _a.call(context, 'alert', options);
}

export { alert as default };
